import axios from 'axios';

// let base = 'https://cloudapi.usr.cn/usrCloud';
let base = '/apis';
let service = '/service'

import store from '../store'
////////////////登录/////////////////////

export const requestLogin = params => { return axios.post(`${base}/user/login`, params).then(res => res.data); };

////////////////用户中心/////////////////////
// 验证验证码
export const chkVerifyCode = params => { return axios.get(`${service}/sysUser/chkVerifyCode`, params).then(res => res.data); };
// 获取用户列表
export const getUsers = params => { return axios.post(`${base}/user/getUsers`, params).then(res => res.data); };

// 保存用户设备列表
export const saveUserDevs = params => { return axios.post(`${service}/sysUser/saveUserDevs`, params).then(res => res.data); };
// 获取单个用户信息
// export const getUser = params => { return axios.post(`${base}/user/getUser`, params).then(res => res.data); };
export const getUser = params => {
    console.log(sessionStorage.getItem('account'),99999);
    if(store.getters.roles === 'admin') {
    // if(true) {
        return  axios({
            method:'post',
            url:`${base}/user/getUser`,
            data: params
        }).then(res => res.data)
    }else {
        return  axios({
            method:'get',
            url:`${service}/sysUser/getByAccount`,
            data: {params: params}
        }).then(res => {
            let obj = {
                tel: res.data.data.mobile
            }
            Object.assign(res.data.data, obj)
            return res.data
        })
    }
};
// 校验验证码
// export const verificationCode = params => { return axios.post(`${base}/user/getVerifyThroughCodeByVerificationCode`, params).then(res => res.data); };
export const verificationCode = params => {
    if(store.getters.roles == 'admin') {
        return  axios({
            method:'post',
            url:`${base}/user/getVerifyThroughCodeByVerificationCode`,
            data: params
        }).then(res => res.data)
    }else {
        let params = {
            mobile: params.emailOrPhoneNumber,
            verifyCode: params.verificationCode
        }
        return  axios({
            method:'post',
            url:`${service}/sysUser/modifyMobile`,
            data:params
        }).then(res => {
            return res.data
        })
    }
};
// 重置密码
export const resetPassword = params => {
    if(store.getters.roles == 'admin') {
        return  axios({
            method:'post',
            url:`${base}/user/modifyPasswordByVerifyThroughCode`,
            data: params
        }).then(res => res.data)
    }else {
        let params = {
            newPassword: params.password,
            oldPassword: params.oldPassword,
            rePassword: params.repassword
        }
        return  axios({
            method:'post',
            url:`${service}/sysUser/modifyPwd`,
            data:params
        }).then(res => {
            return res.data
        })
    }

    return axios.post(`${base}/user/modifyPasswordByVerifyThroughCode`, params).then(res => res.data);

};
// 修改密码
export const modifyPassword = params => { return axios.post(`${base}/user/modifyPassword`, params).then(res => res.data); };
// 注册二级用户
export const registerSubUser = params => { return axios.post(`${base}/user/regUser2`, params).then(res => res.data); };
// 编辑用户信息
export const ModifyUser = params => { return axios.post(`${base}/user/editUser`, params).then(res => res.data); };
// export const ModifyUserL2 = params => { return axios.post(`${service}/sysUser/modifyUser`, params).then(res => res.data); };
// export const ModifyUser = params => {
//
//     console.log(sessionStorage.getItem('account'),'account');
//     if(store.getters.roles == 'admin') {
//         alert()
//         return  axios({
//             method:'post',
//             url:`${base}/user/editUse`,
//             data: params
//         }).then(res => res.data)
//     }else {
//         console.log(params,'params')
//         let params = Object.assign(params, {
//             mobile: params.tel
//         })
//         return  axios({
//             method:'post',
//             url:`${service}/sysUser/modifyUser`,
//             data:params
//         }).then(res => {
//             return res.data
//         })
//     }
//
// };
// 删除用户信息
export const DeleteUser = params => { return axios.post(`${base}/user/deleteUsers`, params).then(res => res.data); };
//获取微信绑定列表
export const getWechatBindList = params => { return axios.post(`${base}/user/getWechatBindList`, params).then(res => res.data); };
export const getWechatBindListL2 = params => { return axios.post(`${service}/user/getWechatBindList`, params).then(res => res.data); };
//解绑微信
export const unbindWechat = params => { return axios.post(`${base}/user/unbindWechat`, params).then(res => res.data); };
export const unbindWechatL2 = params => { return axios.post(`${service}/user/unbindWechat`, params).then(res => res.data); };
//发送验证码
export const sendVerificationCode1 = params => {

    if(store.getters.roles == 'admin') {
        return  axios({
            method:'post',
            url:`${base}/user/sendVerificationCode`,
            data: params
        }).then(res => res.data)
    }else {
        params.emailOrPhoneNumber
        return  axios({
            method:'get',
            url:`${service}/sysUser/sendVerifyCodeSms`,
            data: {params: {mobile:params.emailOrPhoneNumber}}
        }).then(res => {
            return res.data
        })
    }
};
export const sendVerificationCode = params => { return axios.post(`${base}/user/sendVerificationCode`, params).then(res => res.data); };

// 获取用户的设备列表
export const getUserDevs = params => { return axios.get(`${service}/sysUser/getUserDevs`, params).then(res => res.data); };


export const sendVerifyCodeSms = params => { return axios.get(`${service}/sysUser/sendVerifyCodeSms`, params).then(res => res.data); };

export const resetPwd = params => { return axios.post(`${service}/sysUser/resetPwd`, params).then(res => res.data); };
// export const getUserDevsByCondition = params => { return axios.post(`${service}/sysUser/getUserDevsByCondition`, params).then(res => res.data); };


// 保存二级账号手机号
export const modifyMobile = params => { return axios.post(`${service}/sysUser/modifyMobile`, params).then(res => res.data); };



// 获取角色列表
// export const getRoles = params => { return axios.post(`${base}/user/getUsers`, params).then(res => res.data); };

////////////////二级用户用户中心/////////////////////
// 修改密码
export const modifyPasswordL2 = params => { return axios.post(`${service}/sysUser/modifyPwd`, params).then(res => res.data); };
//发送验证码
export const sendVerificationCodeL2 = params => { return axios.get(`${service}/sysUser/sendVerifyCodeSms`, params).then(res => res.data); };
// 重置密码
export const resetPasswordL2 = params => { return axios.post(`${service}/sysUser/resetPwd`, params).then(res => res.data); };
// 修改用户手机号码
export const modifyMobileL2 = params => { return axios.post(`${service}/sysUser/modifyMobile`, params).then(res => res.data); };
// 编辑用户信息
export const ModifyUserL2 = params => { return axios.post(`${service}/sysUser/modifyUser`, params).then(res => res.data); };
// 获取单个用户信息
export const getUserL2 = params => { return axios.get(`${service}/sysUser/getByAccount`, params).then(res => res.data); };
// 获取用户列表
export const getUsersL2 = params => { return axios.post(`${service}/sysUser/listpaging`, params).then(res => res.data); };
// 注册二级用户
export const registerSubUserL2 = params => { return axios.post(`${service}/sysUser/add`, params).then(res => res.data); };
// 删除用户信息
export const DeleteUserL2 = params => { return axios.post(`${service}/sysUser/delByAccount`, params).then(res => res.data); };
// 校验验证码
export const verificationCodeL2 = params => { return axios.get(`${service}/sysUser/chkVerifyCode`, params).then(res => res.data); };
//获取设备列表
export const getDevsL2 = params => { return axios.post(`${service}/sysUser/getUserDevsByCondition`, params).then(res => res.data); };
// 登录
export const requestLoginL2 = params => { return axios.post(`${service}/sysUser/login`, params).then(res => res.data); };
////////////////设备管理/////////////////////
//获取设备列表
export const getDevs = params => { return axios.post(`${base}/dev/getDevs`, params).then(res => res.data); };

////////////////设备管理/////////////////////
//获取设备拓展信息列表
export const getDevExts = params => { return axios.get(`${service}/devExt/list`, params).then(res => res.data); };
//新增设备拓展信息
export const addDevExt = params => { return axios.post(`${service}/devExt/add`, params).then(res => res.data); };
//更新设备拓展信息
export const updateDevExt = params => { return axios.post(`${service}/devExt/update`, params).then(res => res.data); };
//删除设备拓展信息
export const delDevExt = params => { return axios.delete(`${service}/devExt/del`, params).then(res => res.data); };
//根据设备ID获得拓展信息
export const getDevExt = params => { return axios.delete(`${service}/devExt/getByDevId`, params).then(res => res.data); };

////////////////角色管理/////////////////////
//获取角色权限 获取用户的角色列表
export const getRoleMenus = params => { return axios.get(`${service}/sysUser/getUserRoles`, params).then(res => res.data); };
//获取角色列表
export const getRoles = params => { return axios.get(`${service}/sysRole/list`, params).then(res => res.data); };
//获取角色列表
export const getAllRoles = params => { return axios.get(`${service}/sysRole/allList`, params).then(res => res.data); };
//获取对应用户级别的所有角色表列表
export const getAllListOfLevel = params => { return axios.get(`${service}/sysRole/allListOfLevel`, params).then(res => res.data); };
//新增设备拓展信息
export const addRole = params => { return axios.post(`${service}/sysRole/add`, params).then(res => res.data); };
//更新设备拓展信息
export const updateRole = params => { return axios.post(`${service}/sysRole/update`, params).then(res => res.data); };
//删除设备拓展信息
export const delRole = params => { return axios.delete(`${service}/sysRole/del`, params).then(res => res.data); };
//添加用户信息
export const addUser = params => { return axios.post(`${service}/sysUser/add`, params).then(res => res.data); };
//获取用户的角色列表
// export const getUserRoles = params => { return axios.get(`${service}/sysUser/getUserRoles`, params).then(res => res.data); };
//保存用户的角色关系
export const saveUserRoles = params => { return axios.post(`${service}/sysUser/saveUserRoles`, params).then(res => res.data); };


// 获取数据点
export const getData = params => { return axios.post(`${base}/datadic/getData`, params).then(res => res.data); };

//获取在线离线的设备数量
export const getOnlineCountByUid = params => { return axios.post(`${base}/dev/getOnlineCountByUid`, params).then(res => res.data); };

//获取设备下不同通讯协议的数量
export const getProtocolCountByUid = params => { return axios.post(`${base}/dev/getProtocolCountByUid`, params).then(res => res.data); };

//获取设备数量(包括二级用户)
export const getDevCountByUid = params => { return axios.post(`${base}/dev/getDevCountByUid`, params).then(res => res.data); };

//获取设备分组列表
export const getDevGroups = params => { return axios.post(`${base}/dev/getDevGroups`, params).then(res => res.data); };

//添加设备
export const addDevice = params => { return axios.post(`${base}/dev/addDevice`, params).then(res => res.data); };

//批量加设备
export const addDefaultDevs = params => { return axios.post(`${base}/dev/addDefaultDevs`, params).then(res => res.data); };
//获取设备
export const getDevice = params => { return axios.post(`${base}/dev/getDevice`, params).then(res => res.data); };
//获取数据点信息
export const getDataPointInfo = params => { return axios.post(`${base}/datadic/getDataPointInfoByDevice`, params).then(res => res.data); };
//获取最近数据
export const getLastData = params => { return axios.post(`${base}/datadic/getLastData`, params).then(res => res.data); };
//获取某个数据点的历史数据
export const getMultiData = params => { return axios.post(`${base}/datadic/getMultiCurveDataPointHistory`, params).then(res => res.data); };
//设置数据点
export const setDataPoint = params => { return axios.post(`${service}/devData/setDataPoint`, params).then(res => res.data); };


////////////////触发器管理/////////////////////
//获取触发器列表
export const getTriggers = params => { return axios.post(`${base}/trigger/getTriggers`, params).then(res => res.data); };
export const getTriggersL2 = params => { return axios.post(`${service}/trigger/getTriggers`, params).then(res => res.data); };
//查询单个触发器
export const getTrigger = params => { return axios.post(`${base}/trigger/getTrigger`, params).then(res => res.data); };
export const getTriggerL2 = params => { return axios.post(`${service}/trigger/getTrigger`, params).then(res => res.data); };
//删除触发器
export const deleteTrigger = params => { return axios.post(`${base}/trigger/deleteTriggers`, params).then(res => res.data); };
export const deleteTriggerL2 = params => { return axios.post(`${service}/trigger/deleteTriggers`, params).then(res => res.data); };
//添加触发器
export const addTrigger = params => { return axios.post(`${base}/trigger/addTrigger`, params).then(res => res.data); };
export const addTriggerL2 = params => { return axios.post(`${service}/trigger/addTrigger`, params).then(res => res.data); };
//修改触发器
export const editTrigger = params => { return axios.post(`${base}/trigger/editTrigger`, params).then(res => res.data); };
export const editTriggerL2 = params => { return axios.post(`${service}/trigger/editTrigger`, params).then(res => res.data); };
//获取报警历史记录
export const getAlarmHistory = params => { return axios.post(`${base}/trigger/getAlarmHistory`, params).then(res => res.data); };
//获得单个报警记录
export const getAlarmInfo = params => { return axios.post(`${base}/trigger/getAlarmInfo`, params).then(res => res.data); };
//处理告警信息
export const editAlarmInfo = params => { return axios.post(`${base}/trigger/editAlarmInfo`, params).then(res => res.data); };
// 下载告警历史数据excel表
export const downloadAlarmHistoryData = params => { return axios({
    method: 'post',
    responseType: 'blob',
    url: `${base}/download/downloadAlarmHistoryData`,
    data: params
}).then(res => res.data); };

//获取数据模板列表
export const getDataPointTemplateList = params => { return axios.post(`${base}/template/getDataPointTemplateList`, params).then(res => res.data); };
//获取所有预警联系人和组列表
export const getAllAlarmContacts = params => { return axios.post(`${base}/alarmContact/getAllAlarmContacts`, params).then(res => res.data); };
export const getAllAlarmContactsL2 = params => { return axios.post(`${service}/alarmContact/getAllAlarmContacts`, params).then(res => res.data); };
//查询报警联系人列表
export const getAlarmContactUsers = params => { return axios.post(`${base}/alarmContact/getAlarmContactUsers`, params).then(res => res.data); };
export const getAlarmContactUsersL2 = params => { return axios.post(`${service}/alarmContact/getAlarmContactUsers`, params).then(res => res.data); };
//添加报警联系人
export const addAlarmContactUser = params => { return axios.post(`${base}/alarmContact/addAlarmContactUser`, params).then(res => res.data); };
export const addAlarmContactUserL2 = params => { return axios.post(`${service}/alarmContact/addAlarmContactUser`, params).then(res => res.data); };
//修改报警联系人
export const updateAlarmContactUser = params => { return axios.post(`${base}/alarmContact/updateAlarmContactUser`, params).then(res => res.data); };
export const updateAlarmContactUserL2 = params => { return axios.post(`${service}/alarmContact/updateAlarmContactUser`, params).then(res => res.data); };
//删除报警联系人
export const deleteAlarmContactUsers = params => { return axios.post(`${base}/alarmContact/deleteAlarmContactUsers`, params).then(res => res.data); };
export const deleteAlarmContactUsersL2 = params => { return axios.post(`${service}/alarmContact/deleteAlarmContactUsers`, params).then(res => res.data); };
//获取报警组列表
export const getAlarmContactGroups = params => { return axios.post(`${base}/alarmContactGroup/getAlarmContactGroups`, params).then(res => res.data); };
//批量删除报警组
export const deleteAlarmContactGroups = params => { return axios.post(`${base}/alarmContactGroup/deleteAlarmContactGroups`, params).then(res => res.data); };
//添加报警组
export const addAlarmContactGroup = params => { return axios.post(`${base}/alarmContactGroup/addAlarmContactGroup`, params).then(res => res.data); };
//修改报警组
export const updateAlarmContactGroup = params => { return axios.post(`${base}/alarmContactGroup/updateAlarmContactGroup`, params).then(res => res.data); };

//根据设备和从机号获取数据点列表
export const getDatas = params => { return axios.post(`${base}/datadic/getDatas`, params).then(res => res.data); };

// 下载历史数据excel表
export const downloadHistory = params => { return axios({
    method: 'post',
    responseType: 'blob',
    url: `${base}/download/downloadMultiCurveDataPointHistory`,
    data: params
}).then(res => res.data); };

// 获取能耗分析数据
export const getEnergyData = params => { return axios.get(`${service}/devData/allList`, params).then(res => res.data); };

//获取水位和电表的能耗数据
export const waterElecListt = params => { return axios.get(`${service}/devData/waterElecList`, params).then(res => res.data); };

//获取水位和电表的能耗数据
export const getEnergyList = params => { return axios.get(`${service}/devEnergyConsume/allList`, params).then(res => res.data); };

//获取最大水位
export const getMaxWaterLevel = params => { return axios.get(`${service}/devExt/getByDevId`, params).then(res => res.data); };



// WEBPACK FOOTER //
// ./src/api/api.js